import { GetterTree } from 'vuex';
import { ProjectsState } from './types/projects.types';
import { RootState } from '@/store/store';

export const projectsGetters: GetterTree<ProjectsState, RootState> = {

};
